<template>
  <div>
    <h1 class="caption text-uppercase">Pictures</h1>
    <v-row dense>
      <v-menu v-for="(items, name) in pictureBtns" :key="name" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on" class="ma-3">{{ name }}</v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(click, title) in items"
            :key="title"
            @click="click"
          >
            <v-list-item-title>{{ title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
    <v-row dense>
      <v-col v-for="(src, i) in member.featurePictures" :key="i" cols="12" sm="4" md="2">
        <v-card>
          <v-img :src="src" class="grey lighten-3" aspect-ratio="1.3">
            <v-row class="fill-height px-6 py-3" align="end">
              <v-spacer></v-spacer>
              <v-btn fab small dark color="primary" @click="removeFeaturePicture(i)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <!-- IMG UPLOAD DIALOG -->
    <ImageUploadDialog
      ref="imgUpload"
      :title="imgUpload.title"
      :aspect-ratio="imgUpload.aspectRatio"
      :circular="imgUpload.circular"
      @upload="onImageUploaded" />
  </div>
</template>

<script>
import ImageUploadDialog from '../components/ImageUploadDialog'
import { FB_COVER_ASPECT_RATIO } from '../constants'

const MAX_FEATURE_PICS = 6
const UPLOAD_TYPE_PROFILE = 1
const UPLOAD_TYPE_COVER = 2
const UPLOAD_TYPE_FEATURE = 3

export default {
  name: 'FbMemberPictureGroup',
  components: {
    ImageUploadDialog
  },
  props: {
    member: Object
  },
  data() {
    return {
      imgUpload: {},
      pictureBtns: {
        Profile: {
          Change: this.changeProfilePicture,
          Remove: this.removeProfilePicture
        },
        Cover: {
          Change: this.changeCoverPicture,
          Remove: this.removeCoverPicture
        },
        Feature: {
          Add: this.addFeaturePicture
        }
      },
    }
  },
  methods: {
    showUploadDialog(props) {
      this.imgUpload = props
      this.$refs.imgUpload.show()
    },
    changeProfilePicture() {
      this.showUploadDialog({
        type: UPLOAD_TYPE_PROFILE,
        title: 'Change profile picture',
        aspectRatio: 1,
        circular: true
      })
    },
    removeProfilePicture() {
      this.member.profilePicture = ''
    },
    changeCoverPicture() {
      this.showUploadDialog({
        type: UPLOAD_TYPE_COVER,
        title: 'Change cover picture',
        aspectRatio: FB_COVER_ASPECT_RATIO
      })
    },
    removeCoverPicture() {
      this.member.coverPicture = ''
    },
    addFeaturePicture() {
      if (this.member.featurePictures.length >= MAX_FEATURE_PICS)
        alert(`Maximum (${MAX_FEATURE_PICS}) feature pictures reached`)
      else
        this.showUploadDialog({
          type: UPLOAD_TYPE_FEATURE,
          title: 'Add feature picture'
        })
    },
    removeFeaturePicture(idx) {
      this.member.featurePictures.splice(idx, 1)
    },
    onImageUploaded(url) {
      switch (this.imgUpload.type) {
        case UPLOAD_TYPE_PROFILE:
          this.member.profilePicture = url
          break
        case UPLOAD_TYPE_COVER:
          this.member.coverPicture = url
          break
        case UPLOAD_TYPE_FEATURE:
          this.member.featurePictures.push(url)
          break
      }
    }
  }
}
</script>